import { ButtonHTMLAttributes } from 'react'
import s from './ButtonPrimary.module.scss'

interface Props extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'title'> {
    /** Button label. */
    title: string
    /** Keep space in the layout but hide the button (no layout shift). */
    hiddenVisual?: boolean
    /** Shows a spinner left of the label and disables the button. */
    loading?: boolean
}

export const ButtonPrimary = ({
    title,
    className,
    hiddenVisual,
    loading = false,
    disabled,
    tabIndex,
    type = 'button',
    ...rest
}: Props) => {
    const classes = [s.button, hiddenVisual ? s.isHidden : '', loading ? s.isLoading : '', className]
        .filter(Boolean)
        .join(' ')

    return (
        <button
            {...rest}
            type={type}
            className={classes}
            disabled={disabled || loading}
            aria-busy={loading || undefined}
            aria-hidden={hiddenVisual || undefined}
            tabIndex={hiddenVisual ? -1 : tabIndex}
        >
            {loading && <span className={s.spinner} aria-hidden="true" />}
            {title}
        </button>
    )
}

export default ButtonPrimary
